import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { MaskedNumber } from "imask";
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GrupoMotivoPerda } from 'src/app/models/grupo-motivo-perda';
import { GrupoMotivoPerdaService } from 'src/app/services/grupo-motivo-perda.service';


@Component({
  selector: 'app-cadastrar-grupo-motivo-perda',
  templateUrl: './cadastrar-grupo-motivo-perda.component.html',
  styleUrls: ['./cadastrar-grupo-motivo-perda.component.scss']
})
export class CadastrarGrupoMotivoPerdaComponent implements OnInit {
  idGrupo;
  grupoPadrao: GrupoMotivoPerda = {
    id: 0,
    descricao: ''
  }
  grupoFormControl: FormGroup;
  grupoFormData: FormGroup;
  editando = false;

  public readonly MaskedNumber = MaskedNumber;

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private grupoMotivoPerdaService: GrupoMotivoPerdaService,
    private router: Router,
    private carregandoService: CarregandoService
  ) {
    this.createReactiveForm();
   }

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('id')) {
      this.idGrupo = this.route.snapshot.paramMap.get('id');
      this.editando = true;
      this.buscarGrupo();
    } else {
      this.grupoFormControl.reset();
      this.grupoFormData.reset(this.grupoPadrao);
    }
  }

  createReactiveForm() {
    this.grupoFormData = new FormGroup({
      id: new FormControl(this.grupoPadrao.id),
      descricao: new FormControl(this.grupoPadrao.descricao, Validators.required)
    }, {});
  }

  buscarGrupo() {
    this.carregandoService.mostra('buscarGrupo');

    this.grupoMotivoPerdaService.buscar(this.idGrupo).subscribe((embalagem) => {
      this.grupoFormData.setValue({
        ...embalagem
      });

      this.carregandoService.esconde('buscarGrupo');
    }, (erro) => {
      this.carregandoService.esconde('buscarGrupo');
      this.notificacaoService.erro(erro);
    });
  }

  salvar() {
    this.carregandoService.mostra('salvaGrupo');
    const embalagem = this.grupoFormData.getRawValue();

    this.grupoMotivoPerdaService.salvar(embalagem).subscribe(() => {
      this.notificacaoService.sucesso('Grupo salvo com sucesso!!!');
      this.router.navigate(['configuracoes/grupo_motivo_perda']).then(() => {
        this.carregandoService.esconde('salvaGrupo');
      });

    }, (erro) => {
      this.carregandoService.esconde('salvaGrupo');
      this.notificacaoService.erro(erro);
    });
  }
}
